export default {
    title: 'Front Asuse Ai Auth',
};
